import type { App, Directive, DirectiveBinding } from 'vue'

interface ClickOutsideElement extends HTMLElement {
	_clickOutsideHandler?: (event: MouseEvent) => void
}

const clickOutside: Directive = {
	mounted(el: ClickOutsideElement, binding: DirectiveBinding) {
		el._clickOutsideHandler = (event: MouseEvent) => {
			const target = event.target as Node
			if (el !== target && !el.contains(target)) {
				binding.value(event)
			}
		}

		document.addEventListener('click', el._clickOutsideHandler, true)
	},

	beforeUnmount(el: ClickOutsideElement) {
		if (el._clickOutsideHandler) {
			document.removeEventListener('click', el._clickOutsideHandler, true)
			delete el._clickOutsideHandler
		}
	}
}

export function setupClickOutside(app: App) {
	app.directive('click-outside', clickOutside)
}

export default clickOutside
